import { Dispatch, SetStateAction } from 'react'

export interface FileUploadModalProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export type SetFile = Dispatch<SetStateAction<File | null | undefined>>

export enum FileType {
  SPA = 'SPA',
  POSTransactions = 'POSTransactions',
  PriceSheet = 'Pricesheet',
  ClaimResponse = 'ClaimResponse'
}

export interface UploadStatus {
  fileName: string
  status: 'pending' | 'uploading' | 'success' | 'error'
  progress: number
  error?: string
}

export const UPLOAD_LIMITS = {
  MAX_FILES: 500,
  MAX_FILE_SIZE: 250 * 1024 * 1024, // 250 MB, matches the API limit
  CONCURRENT_UPLOADS: 5,
  MAX_BATCH_SIZE: 250 * 1024 * 1024 // bytes uploading at once, to cap API memory
}
